const MuiSnackbar = {
  variants: [
    {
      props: { variant: 'version' },
      style: {
        backgroundColor: 'green',
      },
    },
  ],
};

export default MuiSnackbar;
